import { RoleEnum } from '@zeus/index'
import { Navigate } from 'react-router-dom'
import { useBranding } from '~/helpers/branding/branding-context'
import { useAuth } from '~/helpers/store/auth'
import AdminBilling from '~/pages/backoffice/admin/billing/AdminBilling'
import LearnerCountersTable from '~/pages/backoffice/admin/billing/LearnerCountersTable'

/**
 * Une URL, deux écrans (#45, #51) : l'opérateur plateforme observe toutes les
 * organisations, l'admin gère la facturation de la sienne — formule, montant,
 * historique et coordonnées. Le formateur n'y a pas accès : c'est une donnée
 * contractuelle, sans usage pour l'animation des sessions.
 */
function BillingPage() {
  const { payload } = useAuth()
  const { billingSelfService, loaded } = useBranding()

  if (payload?.role === RoleEnum.SuperAdmin) return <LearnerCountersTable />
  // Ne rien trancher avant la configuration : le réglage par défaut renverrait
  // au tableau de bord un admin dont la facturation est ouverte.
  if (!loaded) return null
  // Libre-service coupé (#165) : rien n'encaisse, l'écran d'achat n'est pas montré.
  if (!billingSelfService) return <Navigate to="/back-office/dashboard" replace />
  return <AdminBilling />
}

export default BillingPage
